import React from 'react';
import SEO from '../components/seo';
import MemberSlider from '../components/company/memberSlider';
const CompanyPage = () => {
  return (
    <>
      <SEO title="Company information" />

      <section className="companyMember">{MemberSlider}</section>
      <section className="companyInfo">
        <div className="companyInfo--inner">
          <h2 className="sectionTitle">Corporate</h2>
          <table className="companytable">
            <tbody>
              <tr>
                <th>会社名</th>
                <td>株式会社サイレンサー （Silencer Inc.）</td>
              </tr>
              <tr>
                <th>住所</th>
                <td>
                  〒733-0003 <br className="sp" />
                  広島県広島市西区三篠町二丁目5番地20号
                </td>
              </tr>
              <tr>
                <th>設立</th>
                <td>2019.04</td>
              </tr>
              <tr>
                <th>代表取締役社長</th>
                <td>野村俊介</td>
              </tr>
              <tr>
                <th>従業員数</th>
                <td>11</td>
              </tr>
              <tr>
                <th>お問い合わせ</th>
                <td>hello@silencer.inc</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section className="companyInfo alcohol">
        <div className="companyInfo--inner">
          <h2 className="sectionTitle">酒類販売管理者標識</h2>
          <table className="companytable">
            <tbody>
              <tr>
                <th>販売場の名称</th>
                <td>株式会社サイレンサー （Silencer Inc.）</td>
              </tr>
              <tr>
                <th>販売場の所在地</th>
                <td>
                  〒733-0003 <br className="sp" />
                  広島県広島市西区三篠町二丁目5番地20号
                </td>
              </tr>
              <tr>
                <th>酒類販売管理者の氏名</th>
                <td>野村俊介</td>
              </tr>
              <tr>
                <th>酒類販売管理研修受講年月日</th>
                <td>2020年8月27日</td>
              </tr>
              <tr>
                <th>次回研修の受講期限</th>
                <td>2023年8月27日</td>
              </tr>
              <tr>
                <th>研修実施団体名</th>
                <td>一般社団法人 日本フランチャイズチェーン協会</td>
              </tr>
            </tbody>
          </table>
          <div className="liqur__policy">
            <ul>
              <li>
                20歳未満の方への酒類の販売はできません。ご購入の際は必ず備考欄に年齢のご記入をお願いいたします。
              </li>
              <li>未成年者の飲酒は法律で固く禁止されています。</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanyPage;
